import { TextareaField, SelectField, TextField } from 'components/Fields'

import Heading from 'components/Heading'
import Button from 'components/Button'

import styles from '../Signup.module.css'
import Achievements from 'components/Forms/Achievements'
import { URL_PATTERN } from 'Utils/String'

const ChooseSocialAchievemnts = ({ setValue, watch, handleSubmit, formField, isSubmitting }) => {
  const { about, title, employmentStatus } = formField

  const submit = () => {
    setValue('step', 'social')
    handleSubmit()
  }

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>
        {`Last Step. SHare your achievements`} <br /> {`and social links.`}
      </Heading>
      <div className={styles['choose-about-wrapper']}>
        <div className={styles['about-wrapper']}>
          <div className={styles['profile-socials']}>
            <Heading element="h4" bold subtitle="Include the full URL">
              Social Network Links
            </Heading>
            <div className={styles['profile-socials-wrapper']}>
              <div className={styles['profile-social-wrapper']}>
                <TextField
                  name={`social_links.instagram`}
                  label={`Instagram`}
                  className={styles['signup-input']}
                  validations={{
                    pattern: {
                      value: URL_PATTERN,
                      message: 'Please enter the full url',
                    },
                  }}
                />
              </div>
              <div className={styles['profile-social-wrapper']}>
                <TextField
                  name={`social_links.facebook`}
                  label={`Facebook`}
                  className={styles['signup-input']}
                  validations={{
                    pattern: {
                      value: URL_PATTERN,
                      message: 'Please enter the full url',
                    },
                  }}
                />
              </div>
              <div className={styles['profile-social-wrapper']}>
                <TextField
                  name={`social_links.twitter`}
                  label={`Twitter`}
                  className={styles['signup-input']}
                  validations={{
                    pattern: {
                      value: URL_PATTERN,
                      message: 'Please enter the full url',
                    },
                  }}
                />
              </div>
              <div className={styles['profile-social-wrapper']}>
                <TextField
                  name={`social_links.youtube`}
                  label={`Youtube`}
                  className={styles['signup-input']}
                  validations={{
                    pattern: {
                      value: URL_PATTERN,
                      message: 'Please enter the full url',
                    },
                  }}
                />
              </div>
              <div className={styles['profile-social-wrapper']}>
                <TextField
                  name={`social_links.linkedin`}
                  label={`Linkedin`}
                  className={styles['signup-input']}
                  validations={{
                    pattern: {
                      value: URL_PATTERN,
                      message: 'Please enter the full url',
                    },
                  }}
                />
              </div>
            </div>
          </div>

          <Achievements name={`personal_achievements`} heading={`Personal Achievements`} />

          <div className={styles['form-footer']}>
            <Button onClick={submit} primary centered disabled={isSubmitting} spinner={isSubmitting}>
              Finish
            </Button>
          </div>
        </div>

        {/* <div className={styles['form-footer']}>
          <Button onClick={submit} block primary={false} disabled={isSubmitting} spinner={isSubmitting}>
            Skip
          </Button>
        </div> */}
      </div>
    </div>
  )
}

export default ChooseSocialAchievemnts
